module.exports = __webpack_public_path__ + "img/img_view_direct_kt_01.4e015edd.png";